module.exports = __webpack_public_path__ + "static/media/error.51238fda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/error.svg
// module id = ./src/resources/images/icons/error.svg
// module chunks = 0